var acc = document.getElementsByClassName("accordiontitle");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
		this.parentElement.classList.toggle("active");
    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
} 


function roundDecimals(num) {
	// Removes zeroes if integer
  // 5.0 > 5
  // 5.5 > 5.5
  //return (num % 1 != 0) ? parseFloat(num).toFixed(1) : num;
  num = parseFloat(num).toFixed(1);
  return parseInt(num) + num % 1;
}


$(document).ready(function() {
  
	//When page loads...
	$("ul.tabs li:first").addClass("active").show(); //Activate first tab
	//On Click Event
	$(".toolsnav .tabbutton").click(function() {
		$(".toolsnav .tabbutton").removeClass("active"); //Remove any "active" class
		$(this).addClass("active"); //Add "active" class to selected tab
		$(".toolpane").hide(); //Hide all tab content
		var activeTab = $(this).attr("data-num"); //Find the attribute value to
		$(activeTab).fadeIn(); //Fade in the active ID content
		return false;
  });

  var $carousel = $('.storieswrapper').flickity({
    cellAlign: 'left',
    contain: false,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false
  });

  // previous
  $('#stories-left-arrow').on( 'click', function(e) {
    e.preventDefault();
    $carousel.flickity('previous');
  });
  // next
  $('#stories-right-arrow').on( 'click', function(e) {
    e.preventDefault();
    $carousel.flickity('next');
  });

  // Phone Detox Calculator
  const calcInput = document.querySelector('.sltn-time-range');
  const hoursText = document.querySelector('#phone-calc-hours');
  const monthsText = document.querySelector('#phone-calc-months');
  const yearsText = document.querySelector('#phone-calc-years');

  $(".sltn-time-range").on('propertychange input', function(event){

    const hours_daily = event.target.value;
    // The formula is hours-daily * days in a weeks
    // * weeks in a month * months in a year, 
    // divided average hours per month
    const months_yearly = hours_daily * 7 * 4.345 * 12 / 730;
    // Five year projection
    const five_years = months_yearly * 5 / 12;
    hoursText.textContent = roundDecimals(hours_daily) + "hs";
    monthsText.textContent = roundDecimals(months_yearly) + " months";
    yearsText.textContent = roundDecimals(five_years) + " years";
  });


  // Popups open and close
  function popupOpenClose(openElem, containerElem, closeElem) {
  
    let openLink = document.querySelector(openElem);
    let closeX = document.querySelector(closeElem);

    $(openLink).on("click", function() {
      $(containerElem).css('display','block');
      $('.w-detox-dark-layer').css('display','block');
    });
    $(closeX).on("click", function() {
      $(containerElem).css('display','none');
      $('.w-detox-dark-layer').css('display','none');
    });
  }

  // Phone Detox - Enroll popup
  popupOpenClose('.herocta .text-block', '.programhero .w-detox-popup', '.programhero .w-detox-popup .close');
  popupOpenClose('.slntbutton.w-button', '.enrollbanner .w-detox-popup', '.enrollbanner .w-detox-popup .close');


  // Phone Detaox Usage Popup
  popupOpenClose('.calccta', '.modal-find-your-usage', '.modal-find-your-usage .close');




  // PDP Accordeon
  $(".product .description > label").on("click", function() {
    let slideHeight = 200;
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".a-content")
        .slideUp(slideHeight);
      $(".description > label i")
        .removeClass("a-open")
        .addClass("a-close");
    } else {
      $(".description > label i")
        .removeClass("a-open")
        .addClass("a-close");
      $(this)
        .find("i")
        .removeClass("a-close")
        .addClass("a-open");
      $(".description > label").removeClass("active");
      $(this).addClass("active");
      $(".a-content").slideUp(slideHeight);
      $(this)
        .siblings(".a-content")
        .slideDown(slideHeight);
    }
  });

  function keepVerticalScroll(){
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }

  //PDP Modal
    // Get the modal
    var modal = document.getElementById("myModal");

    if(modal){
      // Added conditional to avoid errors when modal is not present
      // Get the button that opens the modal
      var btn = document.getElementById("pdpOpenModal");

      // Get the <span> element that closes the modal
      var span = document.getElementsByClassName("close")[0];

      // When the user clicks the button, open the modal 
      btn.onclick = function() {
        modal.style.display = "block";
        document.body.style.top = `-${window.scrollY}px`;
        document.body.classList.add("blocked-scroll"); 
      }

      // When the user clicks on <span> (x), close the modal
      span.onclick = function() {
        modal.style.display = "none";
        document.body.classList.remove("blocked-scroll");
        keepVerticalScroll();
      }

      // When the user clicks anywhere outside of the modal, close it
      window.onclick = function(event) {
        if (event.target == modal) {
          modal.style.display = "none";
          document.body.classList.remove("blocked-scroll");
          keepVerticalScroll();
        }
      }

    }

    
    const read_more_btn = $(".steps-footer .action_button");
    const read_more_txt = $(".steps-footer p");
    let btn_text = 'READ MORE';
    $(read_more_btn).click(function(e){
      e.preventDefault();
      $(read_more_txt).toggleClass("expanded");
      btn_text = (btn_text == 'READ MORE')  ?  'READ LESS' : 'READ MORE';
      $(read_more_btn).text(btn_text);
    });



  //PDP Image Slider Filter

  function PDP_image_filter(item = null){

     // get the original main carousel container!!!!
     const carousel = document.querySelector('.js-product-gallery');
     const navCarousel = document.querySelector('.product-template .product_gallery_nav.product_gallery_nav--bottom-slider');
     let selectedSize = document.querySelector('.swatch_options input:checked+.swatch-element.size').dataset.value.toLowerCase();
     let selectedColor = document.querySelector('.swatch_options input:checked+.swatch-element.color').dataset.value.toLowerCase();

     if(!item) {
       // Get default selected
      item = document.querySelector('.swatch_options input:checked+.swatch-element.color');
     }
    selectedSize = item.dataset.type == 'size' ? item.dataset.value.toLowerCase() : selectedSize;
    selectedColor = item.dataset.type == 'color' ? item.dataset.value.toLowerCase() : selectedColor;
    let color = item.dataset.value.toLowerCase(), count = 0, image;

    /// Iterate each slider element on a copy from the original container
    carousel.querySelectorAll('.gallery-cell').forEach(cellItem => {
      image = cellItem.querySelector('.image__container img').alt;
      inspectCells(image,cellItem);
    }); // end forEach

    /// Iterate Nav Images
    navCarousel.querySelectorAll('.gallery-cell').forEach(cellItem => {
      image = cellItem.querySelector('img').alt;
      inspectCells(image,cellItem);
    }); // end forEach


    function inspectCells(alt,cellItem){
      //test condition: works with Grey or Green!
      // Finds the color & size in "This is the alt text [red,medium]"
      let values = alt.split('[').pop().split(']')[0].toLowerCase().split(";");

      if(values.includes(selectedSize) && values.includes(selectedColor)){
        cellItem.classList.add("enabled-cell");
      } else { //add identifier to remove!
        cellItem.classList.remove("enabled-cell");
      }
    }
   
    function hideCells(element){
      $(element).find(".gallery-cell").hide();
      $(element).find(".enabled-cell").show();
    }

    function resetCells(element){
      $(element).find(".gallery-cell").show().addClass("enabled-cell");
    }

    let enabled_cells = carousel.querySelectorAll(".enabled-cell").length > 0 ? true : false;

    window.flickity_nav.groupCells = true;
    window.flickity_nav.contain = true;
    window.flickity_nav.wrapAround = false;

    if(enabled_cells){
      //Remove unwanted colors!!!!!!
      hideCells(carousel);
      hideCells(navCarousel);

    } else {
      // If no filtered cells available show all 
      resetCells(carousel);
      resetCells(navCarousel);

    }
     
    
    $(carousel).flickity('destroy');
    $(navCarousel).flickity('destroy');
    $(carousel).flickity(window.flickity_pdp);
    $(navCarousel).flickity(window.flickity_nav);
    
  }

  //if page is a PDP...
  elem = document.querySelector('.product');
  if (elem) {

    PDP_image_filter();

    //Get color
    document.querySelectorAll('.product .swatch-element.color,.product .swatch-element.size').forEach(item => {
      item.addEventListener('click', event => {

        PDP_image_filter(item);       
  
      }) //end listener
    }) // end forEach

  } // end if elem is a PDP


  /** PACSAFE custom scripts */
  function pacsafeInit() {
    /* Ticker Tape */
    const tickerTape = document.querySelector('.pacsafe-ticker-tape__image');
    if (tickerTape) {
      document.addEventListener('scroll', function(e) {
        const rect = tickerTape.getBoundingClientRect();
        
        if (rect.y + rect.height < 0) {
          return;
        }
        
        window.requestAnimationFrame(function() {
          tickerTape.style.transform = `translate3d(-${window.scrollY}px, 0, 0)`
        });
      });
    }

    /* PACSAFE Promo */
    const promoBlocks = document.querySelector('.pacsafe-promo__blocks');
    if (promoBlocks) {
      const promoSlider = new Flickity(promoBlocks, {
        freeScroll: false,
        draggable: false,
        prevNextButtons: false,
        pageDots: false
      });

      document.querySelectorAll('.pacsafe-promo__nav').forEach((nav, navIndex) => {
        nav.querySelectorAll('a').forEach((a, i) => {
          if (i == navIndex) {
            a.classList.add('pacsafe-promo__active');
          }

          a.addEventListener('click', (e) => {
            e.preventDefault();
            promoSlider.select(i);
          })
        })
      });
    } /* end PACSAFE Promo */

    /* PACSAFE Features */
    const blocks = document.querySelectorAll('.pacsafe-features__block');
    if (blocks.length > 1) {
      const wrapper = document.querySelector('.pacsafe-features');
      const main = wrapper.querySelector('.pacsafe-features__main-feature');
      const blockCount = blocks.length;
      const images = document.querySelectorAll('.pacsafe-features__image img');
      const nav = document.querySelector('.pacsafe-features__nav');
      const activeClass = 'pacsafe-features__active';

      nav.querySelectorAll('a').forEach(function(link){
        link.addEventListener('click', function(e) {
          e.preventDefault();
          console.log({e})
          showBlock(e.target.dataset.index);
        });
      })

      function selectItem(nodeList, index) {
          nodeList.forEach((el) => {
              el.classList.remove(activeClass);

              if (el.dataset.index == index) {
                  el.classList.add(activeClass);
              }
          });
      }

      function showBlock(index) {
        selectItem(nav.querySelectorAll('a'), index);
        selectItem(blocks, index);
        selectItem(images, index);
      }

      $('.pacsafe-features-left-arrow').click(function(){
        const index = parseInt($('.pacsafe-features__nav .pacsafe-features__active').data('index'));
        let currentIndex = index - 1;
        if(currentIndex >= 0){
          showBlock(currentIndex);
          if(currentIndex === 0){
            $(this).addClass('disable');
          } else {
            $(this).removeClass('disable');
            $('.pacsafe-features-right-arrow').removeClass('disable');
          }
        }
      })

      $('.pacsafe-features-right-arrow').click(function(){
        const index = parseInt($('.pacsafe-features__nav .pacsafe-features__active').data('index'));
        let currentIndex = index + 1;
        if(currentIndex < $('.pacsafe-features__nav a').length){
          showBlock(currentIndex);
          if(currentIndex === (parseInt($('.pacsafe-features__nav a').length) - 1)){
            $(this).addClass('disable');
          } else {
            $(this).removeClass('disable');
            $('.pacsafe-features-left-arrow').removeClass('disable');
          }
        } 

      })

      if($(document).width() < 992){
        var pacsafefeaturesCarousel = $('.pacsafe-features__image').flickity({
          cellAlign: 'left',
          // contain: false,
          // wrapAround: true,
          prevNextButtons: false,
          pageDots: false
        });

        pacsafefeaturesCarousel.on( 'change.flickity', function( event, index ) {
          showBlock(index);
        });

      }
     

    }

    /* Accordion */
    const accordionSection = document.querySelector('.pacsafe-accordion');
    if (accordionSection) {
      $(accordionSection).find('.faqAccordion > dt > button').off();
      const allPanels = $(accordionSection).find('.faqAccordion > dd').hide();

      $(accordionSection).find('.faqAccordion > dt > button').click(function() {
        const $parent = $(this).parent();
        const state = $(this).attr('aria-expanded') === 'false' ? true : false;

        allPanels.slideUp();
        $parent.next().slideDown();
        
        $(this).attr('aria-expanded',state);
        $parent.next().attr('aria-hidden',!state);

        $parent.siblings('dt').children('button').attr('aria-expanded', !state);
        $parent.siblings('dt').next().attr('aria-hidden', state);
        return false;
      });
    }

    var pacsafeCarousel = $('.pacsafe-scroll-gallery__wrapper').flickity({
        cellAlign: 'left',
        // contain: false,
        // wrapAround: true,
        prevNextButtons: false,
        pageDots: false
    });

    $('#pacsafe-left-arrow').on( 'click', function(e) {
        e.preventDefault();
        pacsafeCarousel.flickity('previous');
    });
    $('#pacsafe-right-arrow').on( 'click', function(e) {
        e.preventDefault();
        pacsafeCarousel.flickity('next');
    });

    $('[data-move-btn]').click(function(e){
      e.preventDefault();
      if($(this).hasClass('active')){
        $(this).removeClass('active');
        $(this).find('span').text('READ MORE');
        $('[data-move-text]').css({display: 'none'})
      } else {
        $(this).addClass('active');
        $(this).find('span').text('READ LESS');
        $('[data-move-text]').css({display: 'block'})
      }
      
    })
    
    const heroVideo = $(".pacsafe-hero #hero-video");
    
    if($(document).width() < 480){
      heroVideo.prop('src', `//cdn.shopify.com/s/files/1/0357/9737/t/95/assets/SLNTxPACSAFE_FULLLENGTH_9X16.mp4?v=10655507154937423268`);
    }

    $(".pacsafe-hero .mute-icon").click(function() {
      heroVideo.prop('muted', false);
      $(this).hide();
      $(this).siblings().show();
    })
    $(".pacsafe-hero .unmute-icon").click(function() {
      heroVideo.prop('muted', true);
      $(this).hide();
      $(this).siblings().show();
    })
  }

  pacsafeInit();

  /** end PACSAFE custom scripts */

}); // end on document ready
